export class AppEditionExpireAction {
    static DeactiveTenant = 'DeactiveTenant';
    static AssignToAnotherEdition = 'AssignToAnotherEdition';
}

export enum PreviewButtonTypes {
    Button = "Button",
    Link = "Link"
}
